import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DiretyCheckGuard } from 'src/app/shared/guard/direty-check.guard';
import { PermissionsComponent } from './permissions.component';

const routes: Routes = [
  { path: '', component: PermissionsComponent, canDeactivate: [DiretyCheckGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PermissionsRoutingModule { }
